<script setup lang="ts">
import i18n from '@/lang/i18n';

const emits = defineEmits(['generate'])
const props = withDefaults(
  defineProps<{
    buttonName?: string
  }>(),
  {
    buttonName: i18n.global.t('pages.accounts.form.button.autoCreate'),
  }
)

function ckick() {
  emits("generate")
}
</script>
<template>
  <v-btn
    color="primary"
    class="white--text"
    @click="ckick"
  >
    {{ props.buttonName }}
  </v-btn>
</template>